import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  constructor(private router: Router) { }

  userData:any = [];

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      if(this.userData['access_level'] == 'industry' || this.userData['access_level'] == 'vendor'){
        // this.router.navigate(['dashboard']);
      }
    }
  }
}
